import React from 'react'
import { HeaderComponentProps } from './HeaderComponentProps'
import useStyles from './HeaderComponent.styles'
import NeonLink from '../../utils/NeonLink'
import { buttonClicked } from '../../utils/analytics'
import ComponentType from '../../../data/types/components/ComponentType'

const HeaderComponent: React.FC<HeaderComponentProps> = ({
  button,
  comment = ''
}: HeaderComponentProps) => {
  const classes = useStyles()
  return (
    <div className={classes.header}>
      <NeonLink className={classes.logo} />
      {button && (
        <>
          <div className={classes.grow} />
          <a
            href={button.href}
            className={classes.signInButton}
            onClick={() =>
              buttonClicked(button.text, `${ComponentType.Header} "${comment}"`)
            }
          >
            {button.text}
          </a>
        </>
      )}
    </div>
  )
}

export default HeaderComponent
